export const SET_VARIANT_MODAL_OPENED = 'SET_VARIANT_MODAL_OPENED';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const SET_PROMO_PRODUCT_FOR_CATEGORY_MODAL_OPENED = 'SET_PROMO_PRODUCT_FOR_CATEGORY_MODAL_OPENED';